"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "15", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3V1h5v2H5zM4 3V.5a.5.5 0 01.5-.5h6a.5.5 0 01.5.5V3h4v1h-1.03l-.971 15.531A.5.5 0 0112.5 20h-10a.5.5 0 01-.499-.469L1.031 4H0V3h4zm8.968 1H2.032l.938 15h9.06l.938-15zM4.5 17.023l-.5-11 .998-.046.5 11-.998.046zm5.998 0l.5-11-.998-.046-.5 11 .998.046zM7 6h1v11H7V6z", fill: "#43CBAE" }))); };
exports.default = Component;
//# sourceMappingURL=Trash.js.map